import { useState } from 'react';
import { Modal } from '../common';
import { Input, Button } from '../ui';
import { toast } from 'react-toastify';

function AddParticipantModal({ isOpen, onClose, onSubmit, loading = false }) {
  const [formData, setFormData] = useState({
    prenom: '',
    nom: '',
    email: '',
    phone: '',
  });

  const handleFullNameChange = (e) => {
    const fullName = e.target.value;
    const parts = fullName.trim().split(' ');
    setFormData({
      ...formData,
      prenom: parts[0] || '',
      nom: parts.slice(1).join(' ') || '',
    });
  };

  const handleSubmit = async () => {
    if (!formData.prenom.trim()) {
      toast.error('Le prénom est obligatoire');
      return;
    }
    if (!formData.nom.trim()) {
      toast.error('Le nom est obligatoire');
      return;
    }
    if (!formData.email.trim()) {
      toast.error('L\'email est obligatoire');
      return;
    }

    try {
      await onSubmit(formData);
      setFormData({ prenom: '', nom: '', email: '', phone: '' });
    } catch (err) {
      console.error('Erreur lors de l\'ajout du participant:', err);
    }
  };

  const handleClose = () => {
    setFormData({ prenom: '', nom: '', email: '', phone: '' });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Ajouter un participant"
      description="Créez un nouveau participant pour votre sondage"
      size="md"
      footer={
        <>
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Annuler
          </Button>
          <Button onClick={handleSubmit} disabled={loading}>
            {loading ? 'Ajout en cours...' : 'Ajouter'}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            Nom complet *
          </label>
          <Input
            placeholder="Ex: Jean Dupont"
            value={`${formData.prenom} ${formData.nom}`.trim()}
            onChange={handleFullNameChange}
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            Email *
          </label>
          <Input
            type="email"
            placeholder="Ex: jean@example.com"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            Téléphone
          </label>
          <Input
            type="tel"
            placeholder="Ex: +33 6 12 34 56 78"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddParticipantModal;
